var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.531,19.959c-0.097,0-0.19,0.016-0.283,0.029v-0.029H29.912h-0.001c-1.194,0-2.163,0.968-2.163,2.163 c0,0.002,0,0.003,0,0.005h-0.001V77.87h0.001c0,0.003-0.001,0.006-0.001,0.009c0,1.194,0.969,2.162,2.163,2.162h0h0H40.53h0 c1.194,0,2.162-0.968,2.162-2.162c0-0.003-0.001-0.006-0.001-0.009h0.001V22.127h0c0-0.002,0.001-0.004,0.001-0.005 C42.693,20.927,41.724,19.959,40.531,19.959z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.251,77.87V22.127h0c0-0.002,0.001-0.004,0.001-0.005c0-1.195-0.969-2.163-2.162-2.163c-0.097,0-0.19,0.016-0.283,0.029 v-0.029H59.47H59.47c-1.194,0-2.163,0.968-2.163,2.163c0,0.002,0,0.003,0,0.005h-0.001V77.87h0.001 c0,0.003-0.001,0.006-0.001,0.009c0,1.194,0.969,2.162,2.163,2.162h0h0h10.618h0c1.194,0,2.162-0.968,2.162-2.162 C72.251,77.876,72.25,77.873,72.251,77.87L72.251,77.87z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFPause);
export default __webpack_public_path__ + "static/media/fPause.3a9e373d.svg";
export { ForwardRef as ReactComponent };